import { render, staticRenderFns } from "./SecuredMedia.vue?vue&type=template&id=68ae0312&scoped=true"
import script from "./SecuredMedia.vue?vue&type=script&lang=js"
export * from "./SecuredMedia.vue?vue&type=script&lang=js"
import style0 from "./SecuredMedia.vue?vue&type=style&index=0&id=68ae0312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ae0312",
  null
  
)

export default component.exports